import { render, staticRenderFns } from "./UncookedIngredients.vue?vue&type=template&id=740e0d7b&"
import script from "./UncookedIngredients.vue?vue&type=script&lang=js&"
export * from "./UncookedIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports